/* stylelint-disable selector-pseudo-class-no-unknown, property-no-unknown */
@use "colors";

:export {
  blue: colors.$blue;
  dataVizOrange: colors.$data_viz_orange;
  lightGreen: colors.$light_green;
  mediumGray: colors.$medium_gray;
  lightGrayAccent: colors.$light_gray_accent;
  lightGray: colors.$light_gray;
  neutralGray: colors.$neutral_gray;
  darkGrayText: colors.$dark_grey_on_white;
  amwayWhite: colors.$amway_white;
  amwayBlack: colors.$amway_black;
  white: colors.$white;
}
